var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpiraldeco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 81,
    viewBox: "0 0 135 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91806 49.9619C22.0028 61.9026 36.8028 62.5777 51.7474 62.5108C70.4009 62.4273 89.2792 61.1879 105.328 79.2564",
    stroke: "#FFFCFC",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00001 13.3897C13.3435 28.9979 30.0116 37.2437 48.8584 37.5287C58.7196 37.6773 68.5113 35.4844 78.3848 36.4699C100.629 38.6921 122.198 50.9473 133.689 72.1806",
    stroke: "#FFFCFC",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7457 17.7927C90.0659 13.5211 81.8768 10.5123 73.1604 10.3133C55.8009 9.91803 38.0795 14.6942 23.7085 0.999982",
    stroke: "#FFFCFC",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiraldeco);
export default __webpack_public_path__ + "static/media/spiraldeco.b8ea3597b661d42ed77a9f3d78e729e7.svg";
export { ForwardRef as ReactComponent };